import { createSelector } from 'reselect';

// STUDENTS SELECTOR
export const studentsSelector = (state) => state.students;

// GET STUDENTS SELECTOR
export const getStudentsSelector = createSelector([studentsSelector], ({ data }) => data);
